import React, { useEffect, useReducer, useRef } from 'react';
import classNames from 'classnames';

// REDUX
import { useAppSelector, useAppDispatch } from '@Managers/Redux/Hooks';
import { getMaintananceMode } from '@Managers/Redux/AppState/AppState';

// CSS
import styles from './Maintanance.scss';

//IMAGES
import { useTranslation } from 'react-i18next';
import EventsCenter from '@Managers/Events/EventsCenter';
import { EGameEvents } from '@Managers/Events/GameEvents';

type TMaintananceTimeState = {
    countdown: boolean;
    intid: number;
    time: { h: number; m: number; s: number };
    text: string;
};

const TimeDefault = {
    countdown: false,
    intid: 0,
    time: { h: 0, m: 0, s: 0 },
    text: ''
};

function MaintananceBar() {
    const [state, setState] = useReducer((state: TMaintananceTimeState, newState: any) => ({ ...state, ...newState }), {
        countdown: false,
        intid: 0,
        time: { h: 0, m: 0, s: 0 },
        text: ''
    });

    const { t } = useTranslation();
    const maintananceTime = useAppSelector(getMaintananceMode);
    const dispatch = useAppDispatch();

    const currentState = useRef(TimeDefault);
    currentState.current = state;

    const classes = classNames({
        [styles.maitanance_time__module]: true
    });

    function timer() {
        let id = setInterval(() => {
            const _state = currentState.current as unknown as TMaintananceTimeState;

            if (_state.time.h === 0 && _state.time.m === 0 && _state.time.s === 0) {
                logoutFromGame();
            } else {
                let h = _state.time.m === 0 ? (_state.time.h === 0 ? 0 : _state.time.h - 1) : _state.time.h;
                let m = _state.time.m === 0 && _state.time.h > 0 ? 60 : _state.time.m;

                let time = {
                    h: h,
                    m: _state.time.s === 0 ? (m === 0 ? 0 : m - 1) : m,
                    s: _state.time.s === 0 ? (m === 0 ? 0 : 60) : _state.time.s - 1
                };

                const timeText = `${time.h > 9 ? time.h : `0${time.h}`} : ${time.m > 9 ? time.m : `0${time.m}`} : ${time.s > 9 ? time.s : `0${time.s}`} :`;

                setState({ ..._state, intid: id, time: time, text: t('MAITANANCE_BAR_TEXT').replace('{h:m:s}', timeText) });
            }
        }, 1000);
    }

    async function logoutFromGame() {
        clearInterval(state.intid);
        EventsCenter.emit(EGameEvents.GAME_LOGOUT);
    }

    useEffect(() => {
        if (maintananceTime.time) {
            clearInterval(state.intid);
            setState({ countdown: true, time: maintananceTime.time });
            timer();
        }
    }, [maintananceTime]);

    return (
        <>
            {state.countdown && (
                <div className={classes}>
                    <div className={styles.maitanance_time}>
                        <div className={styles.maitanance_time_text}>
                            <span>{state.text}</span>
                        </div>
                        <button onPointerDown={() => logoutFromGame()}>Logout</button>
                    </div>
                </div>
            )}
        </>
    );
}

export default MaintananceBar;
